<table class="idv-table table-auto w-full text-left text-sm">
	<thead class="bg-grey-veryLight">
		<tr>
			<th *ngIf="hasCheckboxes">
				<app-checkbox
					(change)="selectAllClients()"
					type="clear"
					[(ngModel)]="allClientsSelected"
					[testHook]="testHooks.AllClientsSelectedCheckbox"
				></app-checkbox>
			</th>
			<th class="w-[250px]">Client Name</th>
			<th>Status</th>
			<th>Details</th>
			<th>Requests</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let client of clients">
			<td *ngIf="hasCheckboxes">
				<app-checkbox
					(change)="addClient(client)"
					type="clear"
					[ngModel]="hasClientsSelected(client)"
					[testHook]="testHooks.Checkbox"
				></app-checkbox>
			</td>
			<td>
				<div class="flex gap-x-3">
					<atomic-name-badge
						[firstName]="client.firstName"
						[lastName]="client.lastName"
						size="xsmall"
						[testHook]="testHooks.NameBadge"
					></atomic-name-badge>
					<span>{{ client?.firstName }} {{ client?.lastName }}</span>
				</div>
			</td>
			<td [ngSwitch]="client?.idv?.status">
				<span *ngIf="client?.idv?.status">
					<app-icon
						class="text-blue"
						*ngSwitchCase="idvStatus.REQUEST_SENT"
						[icon]="ICON.RESEND"
					></app-icon>
					<app-icon
						class="text-red"
						*ngSwitchCase="idvStatus.REQUEST_EXPIRED"
						[icon]="ICON.EXCLAMATION"
					></app-icon>
					<app-icon
						class="text-red"
						*ngSwitchCase="idvStatus.REPORT_EXPIRED"
						[icon]="ICON.EXCLAMATION"
					></app-icon>
					<app-icon
						class="text-green"
						*ngSwitchCase="idvStatus.VERIFIED"
						[icon]="ICON.CIRCLE_CHECK"
					></app-icon>
					<app-icon
						class="text-orange"
						*ngSwitchCase="idvStatus.REQUIRES_REVIEW"
						[icon]="ICON.HOURGLASS"
					></app-icon>
					<app-icon
						class="text-red"
						*ngSwitchCase="idvStatus.FLAGGED"
						[icon]="ICON.FILE_SHIELD"
					></app-icon>
				</span>
				<span *ngIf="!client?.idv?.status">
					<app-icon class="text-grey-darker" [icon]="ICON.INFO"></app-icon>
				</span>
				<span class="ml-2">{{ client?.idv?.status || 'Not Initiated' }}</span>

				<span
					[ngSwitch]="client?.idv?.status"
					class="text-blue-highlight ml-2 float-right"
				>
					<button
						*ngSwitchCase="idvStatus.VERIFIED"
						(click)="viewReport(client)"
						[testHook]="testHooks.ViewButton"
					>
						View
					</button>
					<button
						*ngSwitchCase="idvStatus.REQUIRES_REVIEW"
						(click)="reviewReport(client)"
						[testHook]="testHooks.ReviewButton"
					>
						Review
					</button>
					<button
						*ngSwitchCase="idvStatus.REPORT_EXPIRED"
						(click)="viewReport(client)"
						[testHook]="testHooks.ViewButton1"
					>
						View
					</button>
					<button
						*ngSwitchCase="idvStatus.FLAGGED"
						(click)="reviewReport(client)"
						[testHook]="testHooks.ReviewButton1"
					>
						Review
					</button>
				</span>
			</td>
			<td [ngSwitch]="client?.idv?.status">
				<p *ngSwitchCase="idvStatus.REQUEST_EXPIRED">
					Expired
					<strong>{{ client?.idv?.expiryDate | scheduleDateTime }}</strong>
				</p>
				<p *ngSwitchCase="idvStatus.REPORT_EXPIRED">
					Expired
					<strong>{{ client?.idv?.expiryDate | scheduleDateTime }}</strong>
				</p>
				<p *ngSwitchCase="idvStatus.REQUEST_SENT">
					Expires
					<strong>{{ client?.idv?.expiryDate | scheduleDateTime }}</strong>
				</p>
				<p *ngSwitchCase="idvStatus.VERIFIED">
					Expiry:
					<strong>{{ client?.idv?.expiryDate | scheduleDateTime }}</strong>
				</p>
				<p *ngSwitchCase="idvStatus.REQUIRES_REVIEW">
					Expiry:
					<strong>{{ client?.idv?.expiryDate | scheduleDateTime }}</strong>
				</p>
				<p *ngSwitchCase="idvStatus.FLAGGED">
					Expiry:
					<strong>{{ client?.idv?.expiryDate | scheduleDateTime }}</strong>
				</p>
				<p *ngSwitchCase="null">IDV process not initiated</p>
			</td>
			<td>{{ client?.idv?.requestCount || '0' }}</td>
		</tr>
	</tbody>
</table>
